<template>
  <div class="d-flex justify-content-center h-100 logincontainer">
    <b-card header="Sign In">
      <template #footer>
        <b-button
            :disabled="
            wait_auth || !(Boolean(form.username) && Boolean(form.password))
          "
            class="btn float-right login_btn"
            @click="go_auth"
        >
          <span v-if="!wait_auth">Login</span>
          <b-icon v-else animation="cylon" icon="three-dots"></b-icon>
        </b-button>
      </template>
      <b-form @submit.stop.prevent>
        <div class="input-group form-group">
          <div class="input-group-prepend">
            <span class="input-group-text"><b-icon icon="key"/></span>
          </div>
          <b-form-input
              v-model="form.username"
              :readonly="wait_auth"
              placeholder="username"
          />
        </div>
        <div class="input-group form-group">
          <div class="input-group-prepend">
            <span class="input-group-text"><b-icon icon="person-fill"/></span>
          </div>
          <b-form-input
              v-model="form.password"
              :readonly="wait_auth"
              placeholder="password"
              type="password"
              v-on:keyup.enter="go_auth"
          />
        </div>
        <div class="input-group form-group">
          <b-form-valid-feedback
              :state="Boolean(error_message)"
              class="text-white"
          >
            {{ error_message }}
          </b-form-valid-feedback>
        </div>
      </b-form>
    </b-card>
    <div class="d-none d-sm-block appname">Sie Information Portal</div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import VueRamUtils from "vue-ram-utils";

const axios_token = VueRamUtils.axios_token;
export default {
  name: "PageLogin",
  data: function () {
    return {
      error_message: null,
      form: {
        username: "",
        password: "",
      },
    };
  },
  methods: {
    ...mapActions("auth", ["login"]),
    go_auth: function () {
      const self = this;
      this.error_message = null;
      this.login(this.form)
          .then(function (response) {
            console.log("PageLogin login success", response);
            self.$router.push("/");
          })
          .catch(function (error) {
            console.log("PageLogin login error", error);
            if (!error.response) {
              axios_token.centralerror(self)(error);
              return;
            }
            self.error_message = error.response.data.non_field_errors.join(",");
            return error;
          })
          .catch(axios_token.centralerror(self));
    },
  },
  computed: {
    ...mapState("auth", ["wait_auth"]),
  },
};
</script>

<style scoped>
.appname {
  position: fixed;
  bottom: 30px;
  right: 30px;
  font-size: 1.2em;
  background-color: rgba(0, 0, 0, 0.4) !important;
  border-radius: 10px;
  color: white;
  padding-left: 10px;
  padding-right: 10px;
}

.logincontainer {
  background-image: url("~@/assets/login-bg.jpg");
  font-family: "Numans", sans-serif;
}

.container {
  height: 100%;
  align-content: center;
}

.card {
  height: 320px;
  margin-top: auto;
  margin-bottom: auto;
  width: 450px;
  background-color: rgba(255, 255, 255, 0.4) !important;
}

.card-header {
  color: black;
}

.input-group-prepend span {
  width: 50px;
  background-color: #17a2b8;
  color: black;
  border: 0 !important;
}

input:focus {
  outline: 0 0 0 0 !important;
  box-shadow: 0 0 0 0 !important;
}

.remember {
  color: black;
}

.remember input {
  width: 20px;
  height: 20px;
  margin-left: 15px;
  margin-right: 5px;
}

.login_btn {
  color: white;
  background-color: #17a2b8;
  width: 100px;
}

.login_btn:hover {
  color: black;
  background-color: white;
}
</style>

<style>
html,
body,
#app {
  height: 100%;
}
</style>
